var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("prism-editor", {
    staticClass: "my-editor",
    attrs: {
      id: "code-editor",
      highlight: _vm.highlighter,
      "line-numbers": ""
    },
    model: {
      value: _vm.displayValue,
      callback: function($$v) {
        _vm.displayValue = $$v
      },
      expression: "displayValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }